<template>
  <div class="d-flex flex-column" style="gap: 16px;">
    <!-- Jangan dikasih margin, nanti bisa jadi ga fixed navbar nya -->
    <v-col
      class="ma-0 pa-0"
      cols="12"
      no-gutters
      v-for="(item, index) in items"
      :key="index"
    >
      <CardCartTicket
        :fare-id="item.fareID"
        :fare-type="item.fareType"
        :itemName="item.itemName"
        :price="item.convertedPrice"
        :price-total="item.convertedPriceTotal"
        :currency="item.selectedCurrency"
        :clickInformation="clickRouteInformation"
        :routeInformation="item.routeInformation"
        :quantity="item.itemQty"
        v-model="item.itemQty"
        :selected="item.selected"
        :index="index"
        :customerID="item.customerID"
        :customerCartID="item.customerCartIDs[0]"
      />
    </v-col>
  </div>
</template>

<script>
import CardCartTicket from "@/components/CardCartTicket.vue";

export default {
  name: "CartList",
  props: ["items", "clickRouteInformation", "togglebuy", "selected"],
  components: { CardCartTicket },
  methods: {
    getSelected(item) {
      return this.selected.filter(fx => item.customerCartIDs[0] === fx)
    }
  },
};
</script>

<style scoped>

</style>